// src/services/product.service.js
import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL

export const fetchProductById = async (id) => {
  const response = await axios.get(API_URL+`/api/products/${id}`);
  return response.data;
};
